import {
  CONFIG,
  EducationLevelEnum,
  IncomeRangeEnum,
  Location,
  Occupation,
  PercentileCareerDistribution
} from '@lib/utils';
import { Entity, Guard, Result } from '@vantage-point/ddd-core';

import { UserModelBusinessRules } from './user-model.business-rules';

export interface UserModelProps {
  currentAge: number;
  occupationModel?: Occupation;
  locationModel: Location | null;
  currentSalaryAnalysis: PercentileCareerDistribution | null;
  educationLevel: EducationLevelEnum | null;
  incomeRange: IncomeRangeEnum;
  expectedFamilyContribution: number | null;
}

export class UserModel extends Entity<UserModelProps> {
  get currentAge(): number {
    return this.props.currentAge;
  }

  get occupationModel(): Occupation | undefined {
    return this.props.occupationModel;
  }

  get locationModel(): Location | null {
    return this.props.locationModel;
  }

  get currentSalaryAnalysis(): PercentileCareerDistribution | null {
    return this.props.currentSalaryAnalysis;
  }

  get educationLevel(): EducationLevelEnum | null {
    return this.props.educationLevel;
  }

  get incomeRange(): IncomeRangeEnum {
    return this.props.incomeRange;
  }

  get expectedFamilyContribution(): number | null {
    return this.props.expectedFamilyContribution;
  }

  private constructor(props: UserModelProps) {
    super(props);
  }

  public static create(props: UserModelProps): Result<UserModel> {
    const propsResult = Guard.againstNullOrUndefinedBulk([]);

    if (!propsResult.succeeded) {
      return Result.failure<UserModel>(propsResult.message || 'user model properties error');
    }

    props = UserModelBusinessRules.runAllSelfValidationRules(props);

    const userModel = new UserModel({
      ...props
    });

    return Result.success<UserModel>(userModel);
  }

  static get defaultProps(): UserModelProps {
    const props: UserModelProps = {
      currentAge: CONFIG.DEFAULTS.AGE,
      locationModel: null,
      currentSalaryAnalysis: null,
      educationLevel: null,
      incomeRange: IncomeRangeEnum.UNKNOWN,
      expectedFamilyContribution: null
    };

    return props;
  }
}
